// import { FiTrash2 } from "react-icons/fi";
// import { useCart } from "../context/CartContext";

// const CartProduct = ({ item }) => {
//   const { removeFromCart, updateQty } = useCart();

//   return (
//     <div className="flex gap-4 border-b pb-4">
//       {/* PRODUCT IMAGE */}
//       <img
//         src={item.image}
//         alt={item.name}
//         className="w-24 h-28 object-cover rounded"
//       />

//       {/* PRODUCT DETAILS */}
//       <div className="flex-1">
//         <h3 className="font-medium">{item.name}</h3>
//         <p className="text-sm text-gray-500 mt-1">
//           ₹{item.price}
//         </p>

//         {/* QUANTITY + REMOVE */}
//         <div className="flex items-center gap-3 mt-3">
//           <select
//             value={item.qty}
//             onChange={(e) =>
//               updateQty(item.id, Number(e.target.value))
//             }
//             className="border px-2 py-1 rounded"
//           >
//             {[1, 2, 3, 4, 5].map((q) => (
//               <option key={q} value={q}>
//                 {q}
//               </option>
//             ))}
//           </select>

//           <button
//             onClick={() => removeFromCart(item.id)}
//             className="text-red-500 hover:text-red-700 transition"
//           >
//             <FiTrash2 size={18} />
//           </button>
//         </div>
//       </div>

//       {/* TOTAL PRICE */}
//       <p className="font-medium">
//         ₹{item.price * item.qty}
//       </p>
//     </div>
//   );
// };

// export default CartProduct;




import { useState } from "react";
import { FiTrash2 } from "react-icons/fi";
import { useCart } from "../context/CartContext";
import RemoveModal from "./RemoveModal"; 


const CartProduct = ({ item }) => {
  const { removeFromCart, updateQty } = useCart();
 const [showModal, setShowModal] = useState(false);



  const handleRemove = () => {
    removeFromCart(item.id);
    setShowModal(false);
  };
  return (

    <>
 <div className="relative border p-4 flex gap-4">

      {/* DELETE ICON */}
      <button
        // onClick={() => removeFromCart(item.id)} 
        onClick={() => setShowModal(true)}
        className="absolute top-3 right-3 text-red-500 hover:text-red-500"
      >
        <FiTrash2 size={22}/>
      </button>

      {/* IMAGE */}
      <img
        src={item.image}
        alt={item.name}
        className="w-24 h-28 md:w-32 md:h-40 lg:w-36 lg:h-44 object-cover rounded-lg"
      />

      {/* DETAILS */}
      <div className="flex-1">

        <h3 className="text-lg md:text-xl lg:text-2xl font-semibold mb-4">
        
          {item.name}
        </h3>

        <p className="text-sm md:text-base lg:text-lg font-medium">
          ₹{item.price}
        </p>

        {/* QUANTITY */}
        <div className="flex items-center gap-3 mt-4">

          {/* MINUS */}
          <button
            onClick={() => updateQty(item.id, item.qty - 1)}
            className="px-2 py-1 md:px-3 md:py-2 border text-sm md:text-base"
          >
            -
          </button>

          <span className="font-semibold">
            {item.qty}
          </span>

          {/* PLUS */}
          <button
            onClick={() => updateQty(item.id, item.qty + 1)}
            className="px-2 py-1 md:px-3 md:py-2 border text-sm md:text-base"
          >
            +
          </button>
        </div>

        {/* TOTAL */}
        <p className="mt-3 font-semibold">
          Total: ₹{item.price * item.qty}
        </p>
      </div>
    </div>

 {showModal && (
        <RemoveModal
          item={item}
          onClose={() => setShowModal(false)}
          onRemove={handleRemove}
        />
      )}
    </>
   

  );
};

export default CartProduct;